import { render, staticRenderFns } from "./PainelMenuRotas.vue?vue&type=template&id=2bc4bd4e"
import script from "./PainelMenuRotas.vue?vue&type=script&lang=js"
export * from "./PainelMenuRotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports